export const environment = {
  production: true,
  default: {
    language: 'th'
  }
};
